import React, {Component} from "react"
import {injectIntl} from 'react-intl'
import {Link} from "react-router"
import classes from "./CoreLayout.scss"
import UserInfo from "./UserInfo"
import {connect} from "react-redux"
import {Collapse} from 'react-bootstrap'
import {alert} from '../../util/AlertUtil'
import logo from './img/Neeuro_Longtail_Logo.png'
import LogoutLink from '../../components/LogoutLink'

const mapDispatchToProps = {}

const mapStateToProps = (state) => ({
  location: state.router.locationBeforeTransitions,
  user: state.user
})

class NavBar extends Component {

  constructor(...args) {
    super(...args)

    this.state = {
      adminAnalyticsOpen: false,
      adminPerformanceOpen: false,
      enterpriseAnalyticsOpen: false,
      enterprisePerformanceOpen: false,
      userAnalyticsOpen: false,
      userPerformanceOpen: false

    }
  }

  render() {

    const formatMessage = this.props.intl.formatMessage

    const user = this.props.user
    const currentApplication = user.currentApplication
    const appName = currentApplication? currentApplication.name : ''

    const buildMenuButton = (url, faClass, text)=>
      <li>
        <Link to={url} activeClassName={classes.activeMenu}>
          <i className={`fa ${faClass} fa-lg`}></i> <span className="nav-label">{text}</span>
        </Link>
      </li>

    const navHeader =
      <li className="nav-header">
        <UserInfo/>
        <div className="logo-element">
          Neeuro
        </div>
      </li>

    const neeuroLogo =
      <li>
        <img style={{background: '#293846', width: '100%', paddingRight: '15px', paddingBottom: '15px'}}
             src={logo}></img>
      </li>

    const dashboard = buildMenuButton("/dashboard", "fa-dashboard", formatMessage({id:'nav.dashboard'}))
    const admin = buildMenuButton('/users', 'fa-gears', formatMessage({id:'nav.admin'}))

    const enterprise = buildMenuButton('/admin/enterprise', 'fa-sitemap', 'Enterprise Accounts')

    let menuButtons =
      <ul className="nav metismenu" id="side-menu">
        {navHeader}
        {neeuroLogo}
        {dashboard}
        {admin}
        {/*{monitoring}*/}
        {/*{analytics}*/}
        {/*{reports}*/}

        {/*<hr className="hr-line-solid"></hr>*/}
        {/*{userStore}*/}
        <hr className="hr-line-solid"></hr>
        <li>
          <LogoutLink/>
        </li>
      </ul>


    const pathname = this.props.location.pathname

    if (pathname.startsWith('/welcome') || pathname.startsWith('/accessDenied')) {
      menuButtons =
        <ul className="nav metismenu" id="side-menu">
          {navHeader}
          {neeuroLogo}
          <hr className="hr-line-solid"></hr>
          <li>
            <LogoutLink/>
          </li>
        </ul>

    }

    if (pathname.startsWith('/admin')) {
      menuButtons =
        <ul className="nav metismenu" id="side-menu">
          {navHeader}
          {neeuroLogo}
          {enterprise}
          <hr className="hr-line-solid"></hr>
          <li>
            <LogoutLink/>
          </li>
        </ul>

    }

    return (

      <nav className="navbar-default navbar-static-side" role="navigation">
        <div className="sidebar-collapse">
          {menuButtons}
        </div>
      </nav>

    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(NavBar))



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/NavBar.js